import type { GetUserGroupsWithApproversResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetUserGroupsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetUserGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, REFERENCE_DATA_STALE_TIME_MS } from 'src/utils';

export const useGetUserGroups = createQueryHook<
  Record<string, never>,
  GetUserGroupsWithApproversResponseRow[],
  GetUserGroupsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.userGroup.userGroupsWithApprovers.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ user_group: data }),
  // Org reference data; writes invalidate it. See COI-882.
  trpcStaleTime: REFERENCE_DATA_STALE_TIME_MS,
  graphqlDocument: GetUserGroupsDocument,
});
